/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { MAX_REMINDER_TIMES, REMINDER_TIME_REGEX } from '@repo/config';
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

export const updateNotificationPreferencesV1ResponseDataSchema = z.object({
  notificationEnabled: z.boolean(),
  reminderTimes: z.array(z.string().regex(REMINDER_TIME_REGEX)).max(MAX_REMINDER_TIMES),
  remainingSlots: z.number().int().min(0).max(MAX_REMINDER_TIMES),
  timezone: z.string().nullable(),
});

export type IUpdateNotificationPreferencesV1ResponseData = z.infer<
  typeof updateNotificationPreferencesV1ResponseDataSchema
>;

export const updateNotificationPreferencesV1ResponseSchema = createApiResponseSchema(
  updateNotificationPreferencesV1ResponseDataSchema,
) as z.ZodSchema<IAPI<IUpdateNotificationPreferencesV1ResponseData>>;

export type IUpdateNotificationPreferencesV1Response =
  IAPI<IUpdateNotificationPreferencesV1ResponseData>;
